var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18H16C17.1046 18 18 17.1046 18 16V2C18 0.89543 17.1046 0 16 0H2C0.89543 0 0 0.89543 0 2V16C0 17.1046 0.89543 18 2 18Z",
    fill: "#007EBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 15.5H12.8289V10.9505C12.8289 9.70319 12.3549 9.00613 11.3677 9.00613C10.2937 9.00613 9.73252 9.73153 9.73252 10.9505V15.5H7.15833V6.83333H9.73252V8.00073C9.73252 8.00073 10.5065 6.56855 12.3456 6.56855C14.1839 6.56855 15.5 7.69112 15.5 10.0128V15.5ZM4.08734 5.6985C3.21051 5.6985 2.5 4.98241 2.5 4.09925C2.5 3.21609 3.21051 2.5 4.08734 2.5C4.96416 2.5 5.67425 3.21609 5.67425 4.09925C5.67425 4.98241 4.96416 5.6985 4.08734 5.6985ZM2.75814 15.5H5.44235V6.83333H2.75814V15.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.a01c546990673c8318e2f9463166fdca.svg";
export { ForwardRef as ReactComponent };